<template>
  <div class="flex flex-wrap max-w-7xl mx-auto py-4 lg:py-6 xl:py-8 px-2 md:px-4">
    <div class="w-full">
      <Breadcrumb :title="'點讀館'" />
    </div>
    <div class="w-1/3 md:w-1/4 cursor-pointer p-1 lg:p-3">
      <router-link :to="{ name: 'intro'}">
        <div class="square">
          <div class="content intro p-3">
          <progressive-img
            class="w-full h-full object-contain max-w-full"
            :src="cardsData[0].img"
            :placeholder="cardsData[0].img"
            :blur="30"
          />
          </div>
        </div>
        <div class="tracking-wider sm:text-lg lg:text-xl text-center my-3 md:my-4 text-NotoSansBold sm:flex justify-center md:block">
          <h3>智慧點讀筆</h3>
          <h3>介紹及購買</h3>
        </div>
      </router-link>
    </div>
    <div class="w-1/3 md:w-1/4 cursor-pointer p-1 lg:p-3">
      <router-link :to="{ name: 'productsList', params: { category: 'package' }, query: { type: 'PACKAGE', scope: 'smartpen_package_series' } }">
        <div class="square">
          <div class="content buy p-3">
            <progressive-img
              class="w-full h-full object-contain max-w-full"
              :src="cardsData[1].img"
              :placeholder="cardsData[1].img"
              :blur="30"
            />
          </div>
        </div>
        <div class="tracking-wider sm:text-lg lg:text-xl text-center my-3 md:my-4 text-NotoSansBold sm:flex justify-center md:block">
          <h3>點讀套書</h3>
          <h3>購買專區</h3>
        </div>
      </router-link>
    </div>
    <div class="w-1/3 md:w-1/4 cursor-pointer p-1 lg:p-3 hidden md:block">
      <router-link :to="{ name: 'download'}">
        <div class="square">
          <div class="content download p-3">
            <progressive-img
              class="w-full h-full object-contain max-w-full"
              :src="cardsData[2].img"
              :placeholder="cardsData[2].img"
              :blur="30"
            />
          </div>
        </div>
        <div class="tracking-wider sm:text-lg lg:text-xl text-center my-3 md:my-4 text-NotoSansBold sm:flex justify-center md:block">
          <h3>點讀叢書</h3>
          <h3>音檔下載</h3>
        </div>
      </router-link>
    </div>
    <div class="w-1/3 md:w-1/4 cursor-pointer p-1 lg:p-3">
      <a class="cursor-pointer" target="_blank"
        href="https://docs.google.com/forms/d/1xKbpsJpT1ECtrUYZKq153YmzL7fSDckn9VHHNmH9UHY/viewform?edit_requested=true">
        <div class="square">
          <div class="content warranty p-3 flex items-center justify-center">
            <progressive-img
              class="w-full h-full object-contain max-w-full"
              :src="cardsData[3].img"
              :placeholder="cardsData[3].img"
              :blur="30"
            />
          </div>
        </div>
        <div class="tracking-wider sm:text-lg lg:text-xl text-center my-3 md:my-4 text-NotoSansBold sm:flex justify-center md:block">
          <h3>線上保固卡填寫</h3>
        </div>
      </a>
    </div>
  </div>
</template>

<script>
import Breadcrumb from '@/components/modules/Breadcrumb'
export default {
  name: 'landingpage',
  data () {
    return {
      cardsData: [
        { img: require('@/assets/images/readingPen/icon1.png') },
        { img: require('@/assets/images/readingPen/icon2.png') },
        { img: require('@/assets/images/readingPen/download.png') },
        { img: require('@/assets/images/readingPen/tool.png') }
      ]
    }
  },
  components: {
    Breadcrumb
  },
  computed: {
  },
  mounted () {
  },
  updated () {
  },
  methods: {
    toProductWarrantyPage () {
      let self = this
      if (!self.$store.getters.authorized) {
        self.$router.push({ name: 'login' })
      } else {
        self.$router.push({ name: 'productWarranty' })
      }
    }
  }
}
</script>

<style lang="scss" scoped>
  img {
    margin: 0 auto;
  }
.intro {
  background-color: #3B3B98;
  background-image: -webkit-radial-gradient(circle,#6565AD,#3B3B98);
  background-image: -o-radial-gradient(circle,#6565AD,#3B3B98);
  background-image: -moz-radial-gradient(circle,#6565AD,#3B3B98);
  background-image: radial-gradient(circle,#6565AD,#3B3B98);
  &:hover {
    animation-name: intro;
    animation-duration: 0.2s;
    animation-fill-mode: forwards;
  }
}
  @keyframes intro {
    0% {
      background-image: -webkit-radial-gradient(circle,#6565AD 0%,#3B3B98);
      background-image: -o-radial-gradient(circle,#6565AD 0%,#3B3B98);
      background-image: -moz-radial-gradient(circle,#6565AD 0%,#3B3B98);
      background-image: radial-gradient(circle,#6565AD 0%,#3B3B98);
    }
    30% {
      background-image: -webkit-radial-gradient(circle,#6565AD 10%,#3B3B98);
      background-image: -o-radial-gradient(circle,#6565AD 10%,#3B3B98);
      background-image: -moz-radial-gradient(circle,#6565AD 10%,#3B3B98);
      background-image: radial-gradient(circle,#6565AD 10%,#3B3B98);
    }
    50% {
      background-image: -webkit-radial-gradient(circle,#6565AD 20%,#3B3B98);
      background-image: -o-radial-gradient(circle,#6565AD 20%,#3B3B98);
      background-image: -moz-radial-gradient(circle,#6565AD 210%,#3B3B98);
      background-image: radial-gradient(circle,#6565AD 20%,#3B3B98);
    }
    70% {
      background-image: -webkit-radial-gradient(circle,#6565AD 30%,#3B3B98);
      background-image: -o-radial-gradient(circle,#6565AD 30%,#3B3B98);
      background-image: -moz-radial-gradient(circle,#6565AD 30%,#3B3B98);
      background-image: radial-gradient(circle,#6565AD 30%,#3B3B98);
    }
    100% {
      background-image: -webkit-radial-gradient(circle,#6565AD 40%,#3B3B98);
      background-image: -o-radial-gradient(circle,#6565AD 40%,#88889c);
      background-image: -moz-radial-gradient(circle,#6565AD 40%,#3B3B98);
      background-image: radial-gradient(circle,#6565AD 40%,#3B3B98);
    }
  }
.buy {
  background-color: #FEA47F;
  background-image: -webkit-radial-gradient(circle,#FFCFBB,#FEA47F);
  background-image: -o-radial-gradient(circle,#FFCFBB,#FEA47F);
  background-image: -moz-radial-gradient(circle,#FFCFBB,#FEA47F);
  background-image: radial-gradient(circle,#FFCFBB,#FEA47F);
  &:hover {
    animation-name: buy;
    animation-duration: 0.2s;
    animation-fill-mode: forwards;
    // background-image: -webkit-radial-gradient(circle,#FFCFBB 40%,#FEA47F);
    // background-image: -o-radial-gradient(circle,#FFCFBB 40%,#FEA47F);
    // background-image: -moz-radial-gradient(circle,#FFCFBB 40%,#FEA47F);
    // background-image: radial-gradient(circle,#FFCFBB 40%,#FEA47F);
  }
}
  @keyframes buy {
    0% {
    background-image: -webkit-radial-gradient(circle,#FFCFBB 0%,#FEA47F);
    background-image: -o-radial-gradient(circle,#FFCFBB 0%,#FEA47F);
    background-image: -moz-radial-gradient(circle,#FFCFBB 0%,#FEA47F);
    background-image: radial-gradient(circle,#FFCFBB 0%,#FEA47F);
    }
    30% {
      background-image: -webkit-radial-gradient(circle,#FFCFBB 10%,#FEA47F);
      background-image: -o-radial-gradient(circle,#FFCFBB 10%,#FEA47F);
      background-image: -moz-radial-gradient(circle,#FFCFBB 10%,#FEA47F);
      background-image: radial-gradient(circle,#FFCFBB 10%,#FEA47F);
    }
    50% {
      background-image: -webkit-radial-gradient(circle,#FFCFBB 20%,#FEA47F);
      background-image: -o-radial-gradient(circle,#FFCFBB 20%,#FEA47F);
      background-image: -moz-radial-gradient(circle,#FFCFBB 210%,#FEA47F);
      background-image: radial-gradient(circle,#FFCFBB 20%,#FEA47F);
    }
    70% {
      background-image: -webkit-radial-gradient(circle,#FFCFBB 30%,#FEA47F);
      background-image: -o-radial-gradient(circle,#FFCFBB 30%,#FEA47F);
      background-image: -moz-radial-gradient(circle,#FFCFBB 30%,#FEA47F);
      background-image: radial-gradient(circle,#FFCFBB 30%,#FEA47F);
    }
    100% {
      background-image: -webkit-radial-gradient(circle,#FFCFBB 40%,#FEA47F);
      background-image: -o-radial-gradient(circle,#FFCFBB 40%,#88889c);
      background-image: -moz-radial-gradient(circle,#FFCFBB 40%,#FEA47F);
      background-image: radial-gradient(circle,#FFCFBB 40%,#FEA47F);
    }
  }
.download {
  background-color: #74B9FF;
  background-image: -webkit-radial-gradient(circle,#9DCEFF,#74B9FF);
  background-image: -o-radial-gradient(circle,#9DCEFF,#74B9FF);
  background-image: -moz-radial-gradient(circle,#9DCEFF,#74B9FF);
  background-image: radial-gradient(circle,#9DCEFF,#74B9FF);
  &:hover {
    animation-name: download;
    animation-duration: 0.2s;
    animation-fill-mode: forwards;
  }
}
  @keyframes download {
    0% {
      background-image: -webkit-radial-gradient(circle,#9DCEFF 0%,#74B9FF);
      background-image: -o-radial-gradient(circle,#9DCEFF 0%,#74B9FF);
      background-image: -moz-radial-gradient(circle,#9DCEFF 0%,#74B9FF);
      background-image: radial-gradient(circle,#9DCEFF 0%,#74B9FF);
    }
    30% {
      background-image: -webkit-radial-gradient(circle,#9DCEFF 10%,#74B9FF);
      background-image: -o-radial-gradient(circle,#9DCEFF 10%,#74B9FF);
      background-image: -moz-radial-gradient(circle,#9DCEFF 10%,#74B9FF);
      background-image: radial-gradient(circle,#9DCEFF 10%,#74B9FF);
    }
    50% {
      background-image: -webkit-radial-gradient(circle,#9DCEFF 20%,#74B9FF);
      background-image: -o-radial-gradient(circle,#9DCEFF 20%,#74B9FF);
      background-image: -moz-radial-gradient(circle,#9DCEFF 210%,#74B9FF);
      background-image: radial-gradient(circle,#9DCEFF 20%,#74B9FF);
    }
    70% {
      background-image: -webkit-radial-gradient(circle,#9DCEFF 30%,#74B9FF);
      background-image: -o-radial-gradient(circle,#9DCEFF 30%,#74B9FF);
      background-image: -moz-radial-gradient(circle,#9DCEFF 30%,#74B9FF);
      background-image: radial-gradient(circle,#9DCEFF 30%,#74B9FF);
    }
    100% {
      background-image: -webkit-radial-gradient(circle,#9DCEFF 40%,#74B9FF);
      background-image: -o-radial-gradient(circle,#9DCEFF 40%,#88889c);
      background-image: -moz-radial-gradient(circle,#9DCEFF 40%,#74B9FF);
      background-image: radial-gradient(circle,#9DCEFF 40%,#74B9FF);
    }
  }
.warranty {
  background-color: #FDCB6E;
  background-image: -webkit-radial-gradient(circle,#FCE1AE,#FDCB6E);
  background-image: -o-radial-gradient(circle,#FCE1AE,#FDCB6E);
  background-image: -moz-radial-gradient(circle,#FCE1AE,#FDCB6E);
  background-image: radial-gradient(circle,#FCE1AE,#FDCB6E);
  &:hover {
    animation-name: warranty;
    animation-duration: 0.2s;
    animation-fill-mode: forwards;
  }
}
  @keyframes warranty {
    0% {
      background-image: -webkit-radial-gradient(circle,#FCE1AE 0%,#FDCB6E);
      background-image: -o-radial-gradient(circle,#FCE1AE 0%,#FDCB6E);
      background-image: -moz-radial-gradient(circle,#FCE1AE 0%,#FDCB6E);
      background-image: radial-gradient(circle,#FCE1AE 0%,#FDCB6E);
    }
    30% {
      background-image: -webkit-radial-gradient(circle,#FCE1AE 10%,#FDCB6E);
      background-image: -o-radial-gradient(circle,#FCE1AE 10%,#FDCB6E);
      background-image: -moz-radial-gradient(circle,#FCE1AE 10%,#FDCB6E);
      background-image: radial-gradient(circle,#FCE1AE 10%,#FDCB6E);
    }
    50% {
      background-image: -webkit-radial-gradient(circle,#FCE1AE 20%,#FDCB6E);
      background-image: -o-radial-gradient(circle,#FCE1AE 20%,#FDCB6E);
      background-image: -moz-radial-gradient(circle,#FCE1AE 210%,#FDCB6E);
      background-image: radial-gradient(circle,#FCE1AE 20%,#FDCB6E);
    }
    70% {
      background-image: -webkit-radial-gradient(circle,#FCE1AE 30%,#FDCB6E);
      background-image: -o-radial-gradient(circle,#FCE1AE 30%,#FDCB6E);
      background-image: -moz-radial-gradient(circle,#FCE1AE 30%,#FDCB6E);
      background-image: radial-gradient(circle,#FCE1AE 30%,#FDCB6E);
    }
    100% {
      background-image: -webkit-radial-gradient(circle,#FCE1AE 40%,#FDCB6E);
      background-image: -o-radial-gradient(circle,#FCE1AE 40%,#FDCB6E);
      background-image: -moz-radial-gradient(circle,#FCE1AE 40%,#FDCB6E);
      background-image: radial-gradient(circle,#FCE1AE 40%,#FDCB6E);
    }
  }
.square {
  position: relative;
  width: 100%;
  &:after {
    content: "";
    display: block;
    padding-bottom: 100%;
  }
  .content {
    position: absolute;
    width: 100%;
    height: 100%;
    transition: .2s;
    .tool {
      height: 50%;
      width: 50%;
    }
  }
}
</style>
